import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import PreviewHomieLifeMart from "@/pages/PreviewHomieLifeMart";

export const Route = createFileRoute("/preview/homie-lifemart")({
  head: () => seoHead("/preview/homie-lifemart"),
  component: PreviewHomieLifeMart,
});
